export default {
  scheduleCall: 'Schedule a call',
  changeLanguage: 'Français',
  completion: '{{progress}}% completed',
};
